/** @format */

import React, { useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const ListAdminButtons = ({
  documentNumber,
  selectedItemsLength,
  handleToAdd,
  handleToDetail,
  handleToDetailItem,
  handleToUpdate,
  handleLock,
  handleDelete,
  handleRefresh,
  handleCopy,
  handleBulkImport,
  handleExport,
  handleToAssign,
  bulkImportText,
  exportText,
  copyText,
  handleToMiniAdd,
  handleDeleteAll,
  handleToDownload,
  handleToDecryptPassword,
}) => {
  const { t: translator } = useTranslation();
  const { isMobile } = useContext(GlobalContext);
  return (
    <div id="actions" className="mt-3 mb-3">
      {handleToAdd && (
        <button
          id="addBtn"
          className={"btn btn-primary mr-2 pull-right"}
          onClick={handleToAdd}
        >
          <span
            className="icon icon-cancel web-hidden"
            style={{ transform: "rotate(45deg)" }}
          ></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Add")}
          </span>
        </button>
      )}
      {handleToDetail && (
        <button
          id="detailsBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength !== 1}
          onClick={handleToDetail}
        >
          <span className="icon icon-information"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Details")}
          </span>
        </button>
      )}
      {handleToDetailItem && (
        <button
          id="detailsBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength !== 1}
          onClick={handleToDetailItem}
        >
          <span className="icon icon-information"></span>{" "}
          <span className="mob-hidden">{translator("Normativi")}</span>
        </button>
      )}

      {handleToUpdate && (
        <button
          id="updateBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength !== 1}
          onClick={handleToUpdate}
        >
          <span className="icon icon-edit"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Edit")}
          </span>
        </button>
      )}
      {handleToAssign && (
        <button
          id="updateBtn"
          className="btn btn-outline-secondary mr-2"
          onClick={handleToAssign}
        >
          <span className="icon icon-assign"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Assign")}
          </span>
        </button>
      )}
      {handleLock && (
        <button
          id="updateBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength !== 1 || documentNumber}
          onClick={handleLock}
        >
          <span className="icon icon-lock"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Lock")}
          </span>
        </button>
      )}

      {handleDelete && (
        <button
          id="deleteBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength === 0}
          onClick={handleDelete}
        >
          <span className="icon icon-trash"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Delete")}
          </span>
        </button>
      )}
      {handleDeleteAll && (
        <button
          id="deleteAllBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={false}
          onClick={handleDeleteAll}
        >
          <span className="icon icon-trash"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Delete-All")}
          </span>
        </button>
      )}

      {handleRefresh && (
        <button
          className="btn btn-outline-secondary mr-2"
          onClick={handleRefresh}
        >
          <span className="icon-synchronize"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Refresh")}
          </span>
        </button>
      )}

      {handleBulkImport && !handleExport && (
        <button
          id="bulkImportBtn"
          className="btn btn-outline-secondary ml-2 float-right"
          onClick={handleBulkImport}
        >
          <span className="icon icon-move-to-trash"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-BulkImport")}
          </span>
        </button>
      )}

      {handleExport && !handleBulkImport && (
        <button
          id="bulkImportBtn"
          className="btn btn-outline-secondary ml-2 float-right"
          onClick={handleExport}
        >
          <span className="icon icon-move-to-trash"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-DataExport")}
          </span>
        </button>
      )}

      {handleBulkImport && handleExport && (
        <Dropdown className="ml-2 float-right">
          <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
            <span className="icon icon-context-menu"></span>{" "}
            <span className="mob-hidden">
              {translator("ListAdminButtons-Dropdown-Import-Export")}
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleBulkImport}>
              <span className="">
                {isMobile
                  ? translator("ListAdminButtons-Dropdown-BulkImport-Mobile")
                  : translator("ListAdminButtons-Dropdown-BulkImport")}
              </span>
            </Dropdown.Item>
            <Dropdown.Item onClick={handleExport}>
              <span className="">
                {isMobile
                  ? translator("ListAdminButtons-Dropdown-DataExport-Mobile")
                  : translator("ListAdminButtons-Dropdown-DataExport")}
              </span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}

      {handleCopy && (
        <button
          id="copyBtn"
          className="btn btn-outline-secondary ml-2 float-right"
          onClick={handleCopy}
        >
          <span className="icon icon-copy"></span>{" "}
          <span className="mob-hidden">
            {translator("ListAdminButtons-Copy")}
          </span>
        </button>
      )}

      {handleToMiniAdd && (
        <button
          id="addMiniBtn"
          className={"btn btn-primary mr-2 pull-right"}
          onClick={handleToMiniAdd}
        >
          <span
            className="icon icon-cancel web-hidden"
            style={{ transform: "rotate(45deg)" }}
          ></span>{" "}
          <span className="mob-hidden">{translator("Mini cert")}</span>
        </button>
      )}
      {handleToDownload && (
        <button
          id="downloadBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength !== 1}
          onClick={handleToDownload}
        >

          <span className="mob-hidden">
            {translator("ListAdminButtons-Download")}
          </span>
        </button>
      )}
      {handleToDecryptPassword && (
        <button
          id="decryptPasswordBtn"
          className="btn btn-outline-secondary mr-2"
          disabled={selectedItemsLength !== 1}
          onClick={handleToDecryptPassword}
        >
          <span className="mob-hidden">
            {translator("ListAdminButtons-DecryptPassword")}
          </span>
        </button>
      )}
    </div>
  );
};

export default ListAdminButtons;
